export const IMPORT_CSV_MAX_FILE_SIZE_BYTE = 10_000_000 * 10; // 100MB
export const IMPORT_CSV_MAX_FILE_SIZE_UNIT = 'MB';
export const IMPORT_CSV_MAX_FILE_SIZE = `${
  IMPORT_CSV_MAX_FILE_SIZE_BYTE / 1_000_000
}${IMPORT_CSV_MAX_FILE_SIZE_UNIT}`;

export const IMPORT_CSV_UPLOAD_FILE_LIMIT_TOTAL = 1;

export const IMPORT_OPTIONS_SUCCESS_TOAST_MESSAGE_KEY =
  'import-options-success-toast-message';
